export default "__VITE_ASSET__BvmMzhNk__"